import * as React from "react";
import { IRouter, TRoute } from "../../../runtime/Router";
import { TTranslate } from "../../../service/locale/TranslationService";
import { Breadcrumb as BreadcrumbAntd, Icon } from "antd";

export interface State {}

export interface Props {
  router: IRouter;
  translate: TTranslate;
  onRenderLabel: any;
  params?: any;
}

export default class BreadCrumb extends React.Component<Props, State> {
  handleClick(event) {
    if (event.button !== 0 /* left click */) {
      return;
    }

    if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();
  }

  buildBreadcrumbs(location: TRoute, onRenderLabel, params?: any) {
    let crumbs = [
      "",
      ...(location.path || "").split("/").filter(item => item.length > 0)
    ];
    let _path = "";
    return crumbs.map((item, i) => {
      if (_path === "/") {
        _path = "";
      }
      if (item.indexOf(":") === 0) {
        let value = (params || {})[item.substring(1)];
        let name = value;
        if (onRenderLabel) {
          if (onRenderLabel[item.slice(1)]) {
            name = onRenderLabel[item.slice(1)](value);
          }
        }
        _path = [_path, value].join("/");
        return {
          path: _path,
          name,
          disabled: true
        };
      } else {
        const key = `pages.${item || "home"}`;
        _path = [_path, item].join("/");
        return {
          path: _path,
          name: this.props.translate(key) || `__${key}__`,
          disabled: i === crumbs.length - 1 ? true : false
        };
      }
    });
  }

  render() {
    const { router, params, onRenderLabel } = this.props;
    const crumbs = this.buildBreadcrumbs(
      router.location,
      onRenderLabel,
      params
    );
    return (
      <div style={{ paddingTop: 10, paddingBottom: 10 }}>
        <BreadcrumbAntd>
          {(crumbs || []).map((crumb, index) =>
            crumbs.length - 1 === index ? (
              <BreadcrumbAntd.Item key={index}>
                <span>{crumb.name}</span>
              </BreadcrumbAntd.Item>
            ) : crumb.disabled ? (
              <BreadcrumbAntd.Item key={index}>
                {crumb.path === "/" ? (
                  <Icon type="home" />
                ) : (
                  <span>{crumb.name}</span>
                )}
              </BreadcrumbAntd.Item>
            ) : (
              <BreadcrumbAntd.Item key={index} href={crumb.path}>
                {crumb.path === "/" ? (
                  <Icon type="home" />
                ) : (
                  <span>{crumb.name}</span>
                )}
              </BreadcrumbAntd.Item>
            )
          )}
        </BreadcrumbAntd>
      </div>
    );
  }
}
